import React from 'react';
import { useState,useEffect } from 'react';
import NavCard from '../NavCard';
import'../../styles/NavCard.css';
import '../../styles/navoption.css';

const Navoptionsmiphone = ({miPhones}) => {
    console.log("miphones",miPhones);
    
    return (
        <>         
         <div className="navOptions">
         {  miPhones.map((item,index)=>{  
             console.log("111111111",item)
             return(
          <NavCard name={item['name']} price={item['price']} image={item['image']} key={item['image']} index={index}></NavCard> 
             )
              })
         }

         </div>  

        </>
    )
}

export default Navoptionsmiphone;
